import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SelectFormFieldComponent } from '../forms/fields/select-form-field/select-form-field.component';
import { ProblemRecordsFormService } from 'app/problem-records-form/problem-records-form.service';

@Component({
  selector: 'app-add-record-case-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SelectFormFieldComponent,
    TranslateModule
  ],
  templateUrl: './add-record-case-modal.component.html',
  styleUrl: './add-record-case-modal.component.scss'
})
export class AddRecordCaseModalComponent {
  @Input() title!: string;
  @Input() confirmActionLabel!: string;
  @Input() notConfirmActionLabel!: string;

  @Output() onSelectEvent = new EventEmitter<any>();
  @Output() onSearchEvent = new EventEmitter<any>();
  @Output() onClearEvent = new EventEmitter<boolean>();
  @Output() onOpenEvent = new EventEmitter<void>();
  @Output() onScrollEvent = new EventEmitter<any>();

  form!: FormGroup;

  constructor(
    public modalService: NgbActiveModal,
    public problemRecordService: ProblemRecordsFormService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: [null, Validators.required],
      caseTitle: [null],
      caseIdentifier: [null],
      customerRegion: [null],
      customerSite: [null]
    });
  }

  confirm(action: boolean) {
    const result = {
      action: action,
      value: this.form.getRawValue()
    }

    this.modalService.close(result);
    this.resetForm();
  }

  onChangeCaseItem(data: any) {
    this.form.patchValue(data, { emitEvent: false })
  }

  close() {
    this.modalService.dismiss();
    this.resetForm();
  }

  resetForm() {
    setTimeout(() => {
      this.form?.reset();
    }, 300);
  }

  onScrollCases($event: any) {
    this.onScrollEvent.emit($event);

  }

  onSearchForCases($event: any) {
    this.onSearchEvent.emit($event);
  }

  onOpen() {
    this.onOpenEvent.emit();
  }

  onClear() {
    this.onClearEvent.emit();
  }

}
